import { render, staticRenderFns } from "./FlowImage.vue?vue&type=template&id=81e3da34&scoped=true&"
import script from "./FlowImage.vue?vue&type=script&lang=js&"
export * from "./FlowImage.vue?vue&type=script&lang=js&"
import style0 from "./FlowImage.vue?vue&type=style&index=0&id=81e3da34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e3da34",
  null
  
)

export default component.exports